import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4 12a8 8 0 1016 0 8 8 0 00-16 0z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFFFFF",
			stroke: "#FFFFFF",
			strokeWidth: .2,
			d: "M11.603 11.328h.967v3.689a.483.483 0 01-.967 0v-3.689zm.488-2.828c.45 0 .771.347.771.772a.75.75 0 01-.77.763c-.46 0-.791-.337-.791-.763 0-.425.332-.772.79-.772z"
		})
	]
});
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
